module.exports = __webpack_public_path__ + "494cd07c/img/copy-icon.408fdb2d.svg";